<script lang="ts">
import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

export const blankPage = tv({
	slots: {
		root: '@container h-full',
		content: '',
	},
	variants: {
		fill: {
			true: {
				content: 'flex-col',
			},
			false: {
				content: 'flex min-h-full flex-col',
			},
		},
	},
});

export type BlankPageVariants = VariantProps<typeof blankPage>;
</script>

<script setup lang="ts">
import type { BlockRootContext } from '#layers/block-engine/public';
import { computed } from 'vue';
import { PageContent } from '#layers/ui/public';

const props = defineProps<{
	context: BlockRootContext;
}>();

const contentWidth = computed(() => props.context.pageIsFullWidth ? 'full-bleed' : 'narrow-contained');
const fill = computed(() => contentWidth.value === 'full-bleed');
const ui = computed(() => blankPage({ fill: fill.value }));
</script>

<template>
	<div :class="ui.root()">
		<PageContent
			:width="contentWidth"
			:fill
			:class="ui.content()"
		>
			<slot />
		</PageContent>
	</div>
</template>
